import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys'})
// @todo this is not a component it doesn't belong in this folder.
export class KeysPipe implements PipeTransform {
    transform(value: any, args: any[] = null): any {
        return Object.keys(value)//.map(key => value[key]);
    }
}
